import { Box } from '@mui/material';
import { useCallback, useMemo } from 'react';
import type ProductPublishJobStore from '../../../UserData/_stores/Store/ProductPublish/ProductPublishJobStore';
import ProductPublishJobRow from './ProductPublishJobRow';
import { useAppSelector } from '../../../Common/_hooks/useAppSelector';

type Props = {
	batchId?: string
	store: string
}

export default function ProductPublishJobList(props: Props) {
	const listJobs = useAppSelector(state => state.get('userData').get('stores').find(store => store.get('slug') === props.store)?.get('product_publish_summary').get('jobs'))

	const listFilteredJobs = useMemo(() => {
		if (!props.batchId) return listJobs;
		return listJobs?.filter(job => job.get('batch_id') === props.batchId);
	}, [props.batchId, listJobs])

	const renderJob = useCallback((job: ProductPublishJobStore, index: number) => <ProductPublishJobRow
		key={job.get('id')}
		index={index}
		job={job}
		store={props.store}
	/>, [props.store])

	if (!listFilteredJobs || listFilteredJobs.count() === 0) return null;

	return <Box
		component="div"
		sx={{
			border: 1,
			borderColor: 'divider',
			borderRadius: 1,
			bgcolor: 'background.paper',
			overflow: 'hidden',
			width: '100%',
		}}
	>
		{listFilteredJobs.valueSeq().map(renderJob)}
	</Box>
}
